import type { Rule } from "antd/es/form"

export const validateEmailList = (_: Rule, value: string[]) => {
  if (!value || value.length === 0) {
    return Promise.resolve()
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const lower = value.map(v => v.toLowerCase())
  if (new Set(lower).size !== lower.length) {
    return Promise.reject(new Error("Duplicate emails found!"))
  }
  const invalid = value.find(v => !emailRegex.test(v))
  if (invalid) {
    return Promise.reject(new Error(`Invalid email: ${invalid}`))
  }

  return Promise.resolve()
}
